/**
 * StreamRift View - Password-gated command center.
 *
 * SessionStorage gate: unlocked per tab — a same-tab refresh stays open, a new tab re-prompts.
 * Completely isolated from other views.
 */

import { useGate } from '@/hooks/ui/useGate';
import { StreamRiftGate, STREAMRIFT_GATE } from './StreamRiftGate';
import { EyeOfStreamRift } from './EyeOfStreamRift';

export function StreamRiftView() {
  const { unlocked, unlock } = useGate(STREAMRIFT_GATE);

  if (!unlocked) {
    return <StreamRiftGate onUnlock={unlock} />;
  }

  return <EyeOfStreamRift />;
}
